var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-expansion-panel",
    { staticClass: "elevation-0 mb-0", attrs: { value: 0, expand: "" } },
    [
      _vm._l(_vm.probe, function(data, type, index) {
        return [
          !Array.isArray(data)
            ? [
                _c(
                  "v-expansion-panel-content",
                  {
                    key: type + index,
                    staticClass: "background darken-1 mt-1",
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function() {
                            return [
                              _c(
                                "div",
                                [
                                  _c(
                                    "v-chip",
                                    {
                                      staticClass:
                                        "my-0 subheading text-capitalize",
                                      attrs: {
                                        label: "",
                                        small: "",
                                        color: "background"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t" +
                                          _vm._s(type) +
                                          "\n\t\t\t\t\t\t"
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  type === "format"
                                    ? _c(
                                        "v-chip",
                                        {
                                          staticClass: "my-0",
                                          attrs: {
                                            label: "",
                                            small: "",
                                            outline: "",
                                            color: "background lighten-5"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t" +
                                              _vm._s(data.format_long_name) +
                                              "\n\t\t\t\t\t\t"
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      true
                    )
                  },
                  [
                    _vm._v(" "),
                    _c(
                      "v-card",
                      { staticClass: "background" },
                      [
                        _c("v-card-text", { staticClass: "pa-0" }, [
                          _c("table", { staticClass: "table-probe" }, [
                            _c(
                              "tbody",
                              _vm._l(data, function(value, key, index) {
                                return _c("tr", { key: key + index }, [
                                  _c("td", [_vm._v(_vm._s(key))]),
                                  _vm._v(" "),
                                  _vm.$commons.isObject(value)
                                    ? _c("td", [
                                        _c(
                                          "ul",
                                          _vm._l(value, function(
                                            subValue,
                                            subKey,
                                            SubIndex
                                          ) {
                                            return _c(
                                              "li",
                                              { key: subKey + SubIndex },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(subKey) +
                                                    " : " +
                                                    _vm._s(subValue) +
                                                    "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                )
                                              ]
                                            )
                                          }),
                                          0
                                        )
                                      ])
                                    : _c("td", [_vm._v(_vm._s(value))])
                                ])
                              }),
                              0
                            )
                          ])
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            : [
                _vm._l(data, function(stream, streamIndex) {
                  return [
                    true
                      ? _c(
                          "v-expansion-panel-content",
                          {
                            key: "stream" + streamIndex + type,
                            staticClass: "background darken-1 mt-1",
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "header",
                                  fn: function() {
                                    return [
                                      _c(
                                        "div",
                                        [
                                          _c(
                                            "v-chip",
                                            {
                                              staticClass: "my-0 subheading",
                                              attrs: {
                                                label: "",
                                                small: "",
                                                color: "background"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\tStream " +
                                                  _vm._s(stream.codec_type) +
                                                  "\n\t\t\t\t\t\t\t"
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          stream.codec_type === "video"
                                            ? _c(
                                                "v-chip",
                                                {
                                                  staticClass: "my-0",
                                                  attrs: {
                                                    label: "",
                                                    small: "",
                                                    outline: "",
                                                    color:
                                                      "background lighten-5"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        stream.codec_name
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              )
                                            : stream.codec_type === "audio"
                                            ? _c(
                                                "v-chip",
                                                {
                                                  staticClass: "my-0",
                                                  attrs: {
                                                    label: "",
                                                    small: "",
                                                    outline: "",
                                                    color:
                                                      "background lighten-5"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t" +
                                                      _vm._s(stream.channels) +
                                                      " Channel\n\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              )
                                            : stream.codec_type === "data"
                                            ? _c(
                                                "v-chip",
                                                {
                                                  staticClass: "my-0",
                                                  attrs: {
                                                    label: "",
                                                    small: "",
                                                    outline: "",
                                                    color:
                                                      "background lighten-5"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n\t\t\t\t\t\t\t\t" +
                                                      _vm._s(
                                                        stream.codec_tag_string
                                                      ) +
                                                      "\n\t\t\t\t\t\t\t"
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [
                            _vm._v(" "),
                            _c(
                              "v-card",
                              { staticClass: "background" },
                              [
                                _c("v-card-text", { staticClass: "pa-0" }, [
                                  _c("table", { staticClass: "table-probe" }, [
                                    _c(
                                      "tbody",
                                      _vm._l(stream, function(
                                        value,
                                        key,
                                        index
                                      ) {
                                        return _c("tr", { key: key + index }, [
                                          _c("td", [_vm._v(_vm._s(key))]),
                                          _vm._v(" "),
                                          _vm.$commons.isObject(value)
                                            ? _c("td", [
                                                _c(
                                                  "ul",
                                                  _vm._l(value, function(
                                                    subValue,
                                                    subKey,
                                                    SubIndex
                                                  ) {
                                                    return _c(
                                                      "li",
                                                      {
                                                        key: subKey + SubIndex
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                            _vm._s(subKey) +
                                                            " : " +
                                                            _vm._s(subValue) +
                                                            "\n\t\t\t\t\t\t\t\t\t\t\t\t"
                                                        )
                                                      ]
                                                    )
                                                  }),
                                                  0
                                                )
                                              ])
                                            : _c("td", [_vm._v(_vm._s(value))])
                                        ])
                                      }),
                                      0
                                    )
                                  ])
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                })
              ]
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a04c1d3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a04c1d3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/components/ffprobe_display_nexus.vue
// module id = null
// module chunks = 